import { render } from "./RateEvaluationTool.vue?vue&type=template&id=be2464a4&scoped=true&ts=true"
import script from "./RateEvaluationTool.vue?vue&type=script&lang=ts"
export * from "./RateEvaluationTool.vue?vue&type=script&lang=ts"

import "./RateEvaluationTool.vue?vue&type=style&index=0&id=be2464a4&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be2464a4"],['__file',"src/views/RateEvaluationTool.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "be2464a4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('be2464a4', __exports__)) {
    api.reload('be2464a4', __exports__)
  }
  
  module.hot.accept("./RateEvaluationTool.vue?vue&type=template&id=be2464a4&scoped=true&ts=true", () => {
    api.rerender('be2464a4', render)
  })

}


export default __exports__